// extracted by mini-css-extract-plugin
export var active = "_9d-7";
export var container = "_9d-0";
export var evenWidth = "_9d-4";
export var large = "_9d-5";
export var outlet = "_9d-8";
export var slide = "_9d-2";
export var small = "_9d-6";
export var tab = "_9d-3";
export var tabs = "_9d-1";